import React, { useState, useEffect, useContext } from "react"
import { useSnackbar } from "notistack"
import CaixaContext from "../../contexts/caixaContext"
import LoadingContext from "../../contexts/loadingContext"
import ServicosContext from "../../contexts/servicosContext"

import Container from "@material-ui/core/Container"
import RefreshIcon from "@material-ui/icons/Refresh"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import { Row, Col } from "react-bootstrap"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import Button from "@material-ui/core/Button"
import AppBar from "@material-ui/core/AppBar"
import CloudUploadIcon from "@material-ui/icons/CloudUpload"
import CreateIcon from "@material-ui/icons/Create"
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck"

import Chip from "@material-ui/core/Chip"
import TablePagamentos from "./components/TablePagamentos"
import CamposInformativos from "./components/CamposInformativos"
import Dialog from "@material-ui/core/Dialog"
import Slide from "@material-ui/core/Slide"
import Header from "./components/Header"
import useMediaQuery from "@material-ui/core/useMediaQuery"

const useStyles = makeStyles(theme => ({
    divChip: {
        marginBottom: "1em",
        textAlign: "center",
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    appContainer: {
        paddingTop: "6em",
        backgroundColor: "#f4f4f4",
    },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

export default function ModalCaixa(props) {
    const theme = useTheme()
    const classes = useStyles()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const { enqueueSnackbar } = useSnackbar()

    const {
        caixaSelecionada,
        setCaixaSelecionada,
        estabelecimentoSelecionado,
        handleBuscarCaixa,
        handleBuscarCaixasAbertos,
    } = useContext(CaixaContext)

    const { handleAceitadorDePedidos, handleRegistradorDePedidos } = useContext(ServicosContext)

    return (
        <div>
            {!!caixaSelecionada.id && (
                <Dialog
                    fullScreen
                    open={!!caixaSelecionada.id}
                    onClose={() => {
                        setCaixaSelecionada({})
                    }}
                    TransitionComponent={Transition}
                >
                    <Header
                        handleBuscarCaixasAbertos={handleBuscarCaixasAbertos}
                        estabelecimentoSelecionado={estabelecimentoSelecionado}
                    />

                    <Container className={classes.appContainer}>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <div className={classes.divChip}>
                                    {caixaSelecionada.valoresPorTipoCaixa.map((tipo, index) => (
                                        <Chip
                                            key={index}
                                            className={classes.chip}
                                            label={tipo.nome}
                                            color="default"
                                        />
                                    ))}

                                    <Button
                                        size="small"
                                        className={classes.button}
                                        startIcon={<PlaylistAddCheckIcon />}
                                        onClick={() => {
                                            handleAceitadorDePedidos()
                                        }}
                                    >
                                        Recebedor
                                    </Button>
                                    <Button
                                        size="small"
                                        className={classes.button}
                                        startIcon={<CreateIcon />}
                                        onClick={() => {
                                            handleRegistradorDePedidos()
                                        }}
                                    >
                                        Registrador
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            handleBuscarCaixa(caixaSelecionada.id)
                                        }}
                                        size="small"
                                        className={classes.button}
                                        startIcon={<RefreshIcon />}
                                    >
                                        Atualizar
                                    </Button>
                                </div>
                            </Col>
                            <Col xs={12} md={12} lg={5}>
                                <TablePagamentos caixaSelecionada={caixaSelecionada} />
                            </Col>
                            <Col xs={12} md={12} lg={7}>
                                <CamposInformativos />
                            </Col>
                        </Row>
                    </Container>
                </Dialog>
            )}
        </div>
    )
}
